<template>
  <div id="app" class="mainApp">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      lastActivityTime: Date.now(), // 记录用户最后一次操作的时间戳
      inactivityTimeout: 25 * 60 * 1000, // 25分钟
      refreshTime: 2 * 60 * 1000, // 2分钟
      tokenRefreshIntervalTime: 20 * 60 * 1000, // 20分钟
      lastTokenRefreshTime: Date.now(), // 上次刷新token的时间
      tokenRefreshInterval: null, // token刷新定时器
      lastActivityTimeChannel: null, // 跨标签页通信，接收最后活动时间更新的通道
    };
  },
  mounted() {
    // 初始化最后活动时间
    this.lastActivityTime = Date.now();
    // 跨标签页通信，接收最后活动时间更新
    // this.lastActivityTimeChannel = new BroadcastChannel('lastActivityTimeChannel');
    // 跨标签页通信，接收最后活动时间更新
    // this.lastActivityTimeChannel.onmessage = e => {
    //   console.log('收到最后活动时间更新:', e.data);
    //   if (e.data.type === 'update') {
    //     if (e.data.data > this.lastActivityTime) {
    //       this.lastActivityTime = e.data.data;
    //     }
    //   }
    // };
    // 添加全局事件监听
    // this.addGlobalEventListeners();
    // 开始定期刷新token
    this.startTokenRefresh();
    localStorage.setItem('userActive', 'true');
    // 页面刷新时 刷新一次token
    const initRefreshTokenList = ["/", "/login", "/LoginAccess"];
    if (!initRefreshTokenList.includes(window.location.pathname)) {
      this.refreshToken();
    }
  },
  beforeDestroy() {
    // 移除全局事件监听
    // this.removeGlobalEventListeners();
    // 清除定时器
    this.clearTimers();
    // this.lastActivityTimeChannel.close();
  },
  watch: {
    $route(to, from) {
      const notTokenPage = [
        "/login",
        "/LoginIDaaS",
        "/LoginAccess",
        "/userAgree",
        "/userPrivate",
        "/portraitDetail",
        "/portraitSalesman",
        "/SZ_homePageReportNew",
      ];
      if (!localStorage.token && !notTokenPage.includes(to.path)) {
        this.$router.push({
          path: "/login",
        });
      }
    },
  },
  methods: {
    // 添加全局事件监听
    addGlobalEventListeners() {
      // 监听鼠标事件
      document.addEventListener("mousedown", this.updateLastActivityTime);
      // 监听键盘事件
      document.addEventListener("keydown", this.updateLastActivityTime);
      // 监听触摸事件
      // document.addEventListener("touchstart", this.updateLastActivityTime);
      // 监听滚动事件
      // window.addEventListener("scroll", this.updateLastActivityTime, true);
    },

    // 移除全局事件监听
    removeGlobalEventListeners() {
      document.removeEventListener("mousedown", this.updateLastActivityTime);
      document.removeEventListener("keydown", this.updateLastActivityTime);
      // document.removeEventListener("touchstart", this.updateLastActivityTime);
      // window.removeEventListener("scroll", this.updateLastActivityTime, true);
    },

    // 更新最后活动时间
    updateLastActivityTime() {
      this.lastActivityTime = Date.now();
      // 发送消息
      this.lastActivityTimeChannel.postMessage({
        type: "update",
        data: this.lastActivityTime,
      });
      console.log(
        "更新最后活动时间:",
        new Date(this.lastActivityTime).toLocaleString()
      );
    },

    // 检查用户是否活动
    isUserActive() {
      const currentTime = Date.now();
      const timeDiff = currentTime - this.lastActivityTime;
      return timeDiff < this.inactivityTimeout;
    },

    // 开始定期刷新token
    startTokenRefresh() {
      // 每2分钟检查一次，但只在20分钟时刷新token
      this.tokenRefreshInterval = setInterval(() => {
        if (localStorage.token) {
          const currentTime = Date.now();
          const timeSinceLastRefresh = currentTime - this.lastTokenRefreshTime;
          
          if (timeSinceLastRefresh >= this.tokenRefreshIntervalTime) {
            this.refreshToken();
            this.lastTokenRefreshTime = currentTime;
            console.log("刷新token");
          } else {
            console.log("未到20分钟，跳过token刷新");
          }
        } else {
          this.clearTimers();
          localStorage.setItem('userActive', 'false');
          console.log("用户不活动，跳过token刷新");
        }
      }, this.refreshTime);
    },

    // 刷新token逻辑
    async refreshToken() {
      try {
        if (!localStorage.refreshToken) {
          return;
        }
        // post请求 刷新token  后端要 get 传参?????
        const { data } = await this.api.post(
          `/csbr-zuul/user/refreshToken?refreshToken=${localStorage.refreshToken}`
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          return;
        }
        localStorage.setItem("token", data.data.accessToken);
        localStorage.setItem("refreshToken", data.data.refreshToken);
        // LS 标注页镜像：LS api-proxy 每请求现读 ls.oauth2.token（localStorage 优先，无内存缓存），
        // 刷新后不同步镜像的话，已嵌入的标注页仍持旧 token 快照，30min 过期后 API 全 401。
        // 双写 localStorage+sessionStorage 与 LabelToolEmbed.seedToken 同构。
        try {
          localStorage.setItem("ls.oauth2.token", data.data.accessToken);
          sessionStorage.setItem("ls.oauth2.token", data.data.accessToken);
        } catch (e) {
          /* 存储不可用时忽略，不影响主 token 刷新 */
        }
      } catch (error) {
        console.error("token刷新失败:", error);
      }
      this.clearTimers();
      this.startTokenRefresh();
    },

    // 清除所有定时器
    clearTimers() {
      if (this.tokenRefreshInterval) {
        clearInterval(this.tokenRefreshInterval);
      }
    },
  },
};
</script>
<style>
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb {
  /* background: #bfbfbf; */
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: #4fa1a4;
}
div::-webkit-scrollbar-corner {
  background: #4fa1a4;
}
</style>
